// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocSign_documents_filterContainer__XfAma {
  margin-bottom: 20px;
}

.DocSign_documents_requestContainer__tqbvF {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px;
  background-color: var(--branded-light-purple);
  border-radius: 10px;
  border: 1px solid var(--branded-purple-border);
  margin-bottom: 20px;
}

.DocSign_documents_requestContainerInnerLeft__ZKXQn {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: white;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}

.DocSign_documents_requestContainerInnerRight__-9DaO {
  display: flex;
  flex-direction: row;
  flex: 1 1;
  justify-content: center; /* Vertically centers the content */
  align-items: center; /* Horizontally centers the content */
  width: 175px;
  min-width: 175px;
  max-width: 175px;
  background-color: white;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  gap: 10px;
}

.DocSign_documents_itemRow1__h9-Bu {
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}

.DocSign_documents_itemRow2__QNRq- {
  display: flex;
  flex-direction: row;
  border-top: #e7e0f1 solid 1px;
  padding: 20px;
  gap: 20px;
}

.DocSign_documents_item__LpFgX {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.DocSign_documents_status_awaiting_signature__V2aEE {
  background-color: var(--branded-traffic-yellow-bg);
  color: var(--branded-traffic-yellow);
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  width: fit-content;
  font-weight: 600;
  font-size: 14px;
  margin-top: 5px;
}

.DocSign_documents_status_declined__8N118 {
  background-color: var(--branded-traffic-red-bg);
  color: var(--branded-traffic-red);
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  width: fit-content;
  font-weight: 600;
  font-size: 14px;
  margin-top: 5px;
}

.DocSign_documents_status_complete__EzLNe {
  background-color: var(--branded-traffic-green-bg);
  color: var(--branded-traffic-green);
  border-radius: 4px;
  padding: 4px 10px 4px 10px;
  width: fit-content;
  font-weight: 600;
  font-size: 14px;
  margin-top: 5px;
}

.DocSign_documents_status_count__qd\\+Gz {
  font-weight: 400;
  font-size: 14px;
  margin-top: 5px;
}

/* tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .DocSign_documents_requestContainer__tqbvF {
    flex-direction: column;
  }

  .DocSign_documents_requestContainerInnerLeft__ZKXQn {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .DocSign_documents_requestContainerInnerRight__-9DaO {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    min-width: none;
    max-width: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    padding: 20px;
  }
}

/* mobile */
@media (max-width: 768px) {
  .DocSign_documents_itemRow1__h9-Bu {
    flex-wrap: wrap;
  }

  .DocSign_documents_itemRow2__QNRq- {
    flex-wrap: wrap;
    border-top: none;
  }

  .DocSign_documents_requestContainer__tqbvF {
    flex-direction: column;
  }

  .DocSign_documents_requestContainerInnerLeft__ZKXQn {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .DocSign_documents_requestContainerInnerRight__-9DaO {
    display: flex;
    flex-direction: row;
    justify-content: start;
    width: 100%;
    min-width: none;
    max-width: none;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border-bottom-left-radius: 7px;
    border-bottom-right-radius: 7px;
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/documentSigning/DocSign.documents.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,6CAA6C;EAC7C,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,uBAAuB,EAAE,mCAAmC;EAC5D,mBAAmB,EAAE,qCAAqC;EAC1D,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;EACjC,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;EACnC,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;EACf;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,eAAe;IACf,2BAA2B;IAC3B,4BAA4B;IAC5B,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;EACf;AACF","sourcesContent":[".filterContainer {\n  margin-bottom: 20px;\n}\n\n.requestContainer {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  padding: 20px;\n  background-color: var(--branded-light-purple);\n  border-radius: 10px;\n  border: 1px solid var(--branded-purple-border);\n  margin-bottom: 20px;\n}\n\n.requestContainerInnerLeft {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: white;\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n}\n\n.requestContainerInnerRight {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  justify-content: center; /* Vertically centers the content */\n  align-items: center; /* Horizontally centers the content */\n  width: 175px;\n  min-width: 175px;\n  max-width: 175px;\n  background-color: white;\n  border-top-right-radius: 7px;\n  border-bottom-right-radius: 7px;\n  gap: 10px;\n}\n\n.itemRow1 {\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n\n.itemRow2 {\n  display: flex;\n  flex-direction: row;\n  border-top: #e7e0f1 solid 1px;\n  padding: 20px;\n  gap: 20px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n.status_awaiting_signature {\n  background-color: var(--branded-traffic-yellow-bg);\n  color: var(--branded-traffic-yellow);\n  border-radius: 4px;\n  padding: 4px 10px 4px 10px;\n  width: fit-content;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.status_declined {\n  background-color: var(--branded-traffic-red-bg);\n  color: var(--branded-traffic-red);\n  border-radius: 4px;\n  padding: 4px 10px 4px 10px;\n  width: fit-content;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.status_complete {\n  background-color: var(--branded-traffic-green-bg);\n  color: var(--branded-traffic-green);\n  border-radius: 4px;\n  padding: 4px 10px 4px 10px;\n  width: fit-content;\n  font-weight: 600;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n.status_count {\n  font-weight: 400;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* tablet */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .requestContainer {\n    flex-direction: column;\n  }\n\n  .requestContainerInnerLeft {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    border-top-left-radius: 7px;\n    border-top-right-radius: 7px;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  .requestContainerInnerRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    width: 100%;\n    min-width: none;\n    max-width: none;\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    border-bottom-left-radius: 7px;\n    border-bottom-right-radius: 7px;\n    padding: 20px;\n  }\n}\n\n/* mobile */\n@media (max-width: 768px) {\n  .itemRow1 {\n    flex-wrap: wrap;\n  }\n\n  .itemRow2 {\n    flex-wrap: wrap;\n    border-top: none;\n  }\n\n  .requestContainer {\n    flex-direction: column;\n  }\n\n  .requestContainerInnerLeft {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    border-top-left-radius: 7px;\n    border-top-right-radius: 7px;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n\n  .requestContainerInnerRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    width: 100%;\n    min-width: none;\n    max-width: none;\n    border-top-left-radius: 0px;\n    border-top-right-radius: 0px;\n    border-bottom-left-radius: 7px;\n    border-bottom-right-radius: 7px;\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterContainer": `DocSign_documents_filterContainer__XfAma`,
	"requestContainer": `DocSign_documents_requestContainer__tqbvF`,
	"requestContainerInnerLeft": `DocSign_documents_requestContainerInnerLeft__ZKXQn`,
	"requestContainerInnerRight": `DocSign_documents_requestContainerInnerRight__-9DaO`,
	"itemRow1": `DocSign_documents_itemRow1__h9-Bu`,
	"itemRow2": `DocSign_documents_itemRow2__QNRq-`,
	"item": `DocSign_documents_item__LpFgX`,
	"status_awaiting_signature": `DocSign_documents_status_awaiting_signature__V2aEE`,
	"status_declined": `DocSign_documents_status_declined__8N118`,
	"status_complete": `DocSign_documents_status_complete__EzLNe`,
	"status_count": `DocSign_documents_status_count__qd+Gz`
};
export default ___CSS_LOADER_EXPORT___;
